<template>
  <b-card title="Data Konsultasi Per hari">
    <div>
      <!-- Table Container Card -->
      <b-card no-body class="mb-0">
        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <!-- Per Page -->
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>Show</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
              />
              <label>entries</label>
            </b-col>

            <!-- Search -->
            <b-col cols="12" md="6">
              <div class="d-flex align-items-center justify-content-end">
                <b-col cols="12" md="4" class="mb-md-0 mb-2">
                  <flat-pickr
                    v-model="dataFilter"
                    :config="{ mode: 'range' }"
                    class="form-control flat-picker bg-transparent border-1 shadow-none"
                    placeholder="YYYY-MM-DD to YYYY-MM-DD"
                    @input="val => satkerFilter()"
                  />
                </b-col>
              </div>
            </b-col>
          </b-row>
        </div>

        <b-table
          ref="refUserListTable"
          class="position-relative"
          :items="fetchDatas"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="No matching records found"
          :sort-desc.sync="isSortDirDesc"
        >
          <!-- Column: User -->
          <template #cell(jenis_keterampilan)="data">
            <b-media vertical-align="center">
              {{ data.item.jenis_keterampilan }}
              <small class="text-muted">{{ data.item.alamat }}</small>
            </b-media>
          </template>

          <template #cell(status_keterampilan)="data">
            <b-media vertical-align="center">
              {{ data.item.status_keterampilan }}
              <small class="text-muted">{{ data.item.alamat }}</small>
            </b-media>
          </template>

          <!-- <template #cell(jawaban_faq)="data">
            <b-media vertical-align="center">
                {{ data.item.jawaban_faq }}
              <small class="text-muted">{{ data.item.alamat }}</small>
            </b-media>
          </template> -->

          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <b-button
              class="mr-1 btn-icon btn btn-relief-primary"
              variant="success"
              :to="{ name: 'pages-tiket-lihat', params: { id: data.item.id } }"
              title="Lihat Data"
              alt="Lihat Data"
            >
              <feather-icon icon="EyeIcon" />
              <!-- <span class="align-middle ml-50">Edit</span> //-->
            </b-button>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >Menampilkan {{ dataMeta.from }} per {{ dataMeta.to }} dari {{ dataMeta.of }} data
              </span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalUsers"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
// import AppEchartBar from '@core/components/charts/echart/AppEchartBar.vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import { getKategoriJenisTiket, deleteJenisTiket } from '@/connection-api/master'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { avatarText } from '@core/utils/filter'
import storeModule from '@/connection-api/tiket-table-all-dashboard/storeModule'
import useList from '@/connection-api/tiket-table-all-dashboard/list'
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    // BRow,
    // BCol,
    BCard,
    // AppEchartBar,
    // BCardHeader,
    // BCardSubTitle,
    // BCardTitle,
    // BCardText,
    // BCardBody,
    // BMedia,
    // BAvatar,
    // BMediaAside,
    // BMediaBody,
    // VueApexCharts,
    flatPickr,
    BRow,
    BCol,
    // BFormInput,
    BButton,
    BTable,
    BMedia,
    BPagination,
    vSelect,
  },
  // props: {
  //   dataOptionChart: {},
  // },
  props: {
    dataFilter: {},
    satkerOptions: {
      type: Array,
      required: true,
    },
  },
  methods: {
    satkerFilter() {
      // console.log(this.dataFilter)
      this.searchQuery = this.dataFilter
      // this.$emit('emitFilter', this.dataFilter)
    },
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = 'keterampilan'
    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) {
      store.registerModule(USER_APP_STORE_MODULE_NAME, storeModule)
    }

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) {
        store.unregisterModule(USER_APP_STORE_MODULE_NAME)
      }
    })

    const isAddNewUserSidebarActive = ref(false)

    const {
      fetchDatas,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      jenisUptFilter,
      kanwilFilter,
      uptFilter,
      jenisAssetFilter,
      statusAssetFilter,
    } = useList()

    return {
      // Sidebar
      isAddNewUserSidebarActive,

      fetchDatas,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
